<div class="modal-container">
  <!-- Sticky Header -->
  <div class="modal-header">
    <h2>Two factor authentication</h2>
  </div>

  <!-- Content Area -->
  <div class="modal-content">
    @if (state === 'loading') {
      <app-spinner></app-spinner>
    }

    @if (state === 'confirmation') {
      <div>
        <p [innerHTML]="initialMessage()"></p>
      </div>
    }

    @if (state === 'displayQr') {
      <div>
        <p>Scan this code in your two factor application:</p>
        <div class="content m-y-24">
          <img [src]="twoFactorAuthData.qr" alt="QR" />
        </div>
        <p class="m-y-24">
          Or type the code: <strong>{{ twoFactorAuthData.secret }}</strong>
        </p>
        <app-notice
          [label]="'Info'"
        [text]="
          'To use two factor authentication you have to have a 2fa application (like Google Authenticator). Below is the list of supported applications.'
        "
        ></app-notice>
        <div class="m-y-24">
          <app-app-auth-list></app-app-auth-list>
        </div>
        <mat-checkbox [(ngModel)]="confirmation" class="m-r-16"
          >I confirm that I have added this code to my 2FA application
        </mat-checkbox>
      </div>
    }
  </div>

  <!-- Bottom Sheet -->
  <div class="modal-footer">
    <div class="footer-actions">
      @if (state === 'confirmation') {
        <div class="d-flex justify-content-between w-full">
          @if (!data.disableCancel) {
            <button
              mat-raised-button
              color="accent"
              type="button"
              (click)="cancel()"
              >
              Cancel
            </button>
          }
          <button mat-raised-button color="accent" type="button" (click)="confirm()">
            Yes, confirm
          </button>
          @if (data.disableCancel) {
            <button
              mat-raised-button
              color="accent"
              type="button"
              (click)="logout()"
              >
              Logout
            </button>
          }
        </div>
      }

      @if (state === 'displayQr') {
        <div>
          <button
            [disabled]="!confirmation"
            mat-raised-button
            color="accent"
            type="button"
            (click)="cancel()"
            >
            Confirm
          </button>
        </div>
      }
    </div>
  </div>
</div>
